import { Component } from '@angular/core';
import { Item } from 'src/app/models/item';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-dashboard-reseller-panel',
  templateUrl: './dashboard-reseller-panel.component.html',
  styleUrls: ['./dashboard-reseller-panel.component.css']
})
export class DashboardResellerPanelComponent {

  activeReseller:number = 0;
  blockedReseller:number = 0;
  onboardedReseller:number = 0;

  topPerfReseller:any=[];
  topRecentReseller:any=[];

  graphdataReseller: any[] = [];
  visibleColumnDataReseller: Item[] = [];
  visibleColumnsIdReseller:any[] = [];
  graphHeaderReseller :any[]=[];
  constructor(private spinner: LoaderService, private dashboardSevice:DashboardService){

  }  

  GetTop5ResDashboardData(StartDate:string,EndDate:string,policyType:number){
    let obj={
      DistributorId:0,
      ResellerId:0,
      AgentId:0,
      SystemCompanyId:1,
      StartDate:StartDate,//moment(this.selectedStartDate).format('YYYY-MM-DD'),
      EndDate:EndDate,//moment(this.selectedEndDate).format('YYYY-MM-DD'),
      policyType:policyType//this.policyType
    }
    this.dashboardResellerStatus(obj);
    this.dashboardSevice.GetTop5ResDashboardData(obj).then((response)=> { 
    if(response?.isSuccess && response?.result?.length > 0)
    {
      for(let i=0;i<response?.result?.length;i++)
      {
        if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
        {
          switch(i)
          {case 0 :
              this.topRecentReseller= JSON.parse(response.result[i]);            
            break;
            case 1 :
              this.topPerfReseller= JSON.parse(response.result[i]);              
            break;
          }          
        }
      }

      if(this.topPerfReseller && this.topPerfReseller.length > 0)
      {
        this.graphHeaderReseller=Object.keys(this.topPerfReseller[0]).map((m:any)=>{return {key: m,type:"System.String"}});
        this.visibleColumnDataReseller =  this.graphHeaderReseller.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
        this.visibleColumnsIdReseller = this.visibleColumnDataReseller.map((m:any)=>{return m.id.toString()});
        this.graphdataReseller=this.topPerfReseller.map((m:any) => {return Object.values(m)});
      }
      else
      {
        this.graphHeaderReseller = [];
        this.visibleColumnDataReseller = [];
        this.visibleColumnsIdReseller = [];
        this.graphdataReseller = [];
      }  
      }
    });
  }

  async dashboardResellerStatus(obj:any){
    this.dashboardSevice.DashboardResellerStatus(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        for(let i=0;i<response?.result?.length;i++)
        {
          if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
          {
            switch(i)
            {
              case 0 :
              this.onboardedReseller= JSON.parse(response.result[i])[0].count;
              //let onBoardedAgentOld = JSON.parse(response.result[i])[1].count;
              //this. onBoardedAgentRatio = getGrowthRatio((onBoardedAgentOld??0).toString(),(this.onBoardedAgent??0).toString());
              break;
              case 1 :
              this.blockedReseller= JSON.parse(response.result[i])[0].count;
              //let inProgressAgentOld= JSON.parse(response.result[i])[1].count;
              //this.inProgressAgentRatio = getGrowthRatio((inProgressAgentOld??0).toString(),(this.inProgressAgent??0).toString());
              break;
              case 2 :
                this.activeReseller= JSON.parse(response.result[i])[0].count;
                break;
              // this.blokedAgent= JSON.parse(response.result[i])[0].count;
              // let blokedAgentOld= JSON.parse(response.result[i])[1].count;
              // //this.blokedAgentRatio = getGrowthRatio((blokedAgentOld??0).toString(),(this.blokedAgent??0).toString());
              // break;
              // case 3 :
              // this.totalCustomers= JSON.parse(response.result[i])[0].count;
              // let totalCustomersOld = JSON.parse(response.result[i])[1].count;
              // //this.totalCustomersRatio = getGrowthRatio((totalCustomersOld??0).toString(),(this.totalCustomers??0).toString());
              // break;
            }
            
          }
        } 
      }
    });
  }

}
